// Registers the runtime federated remotes from app settings; isolated so the MF runtime stays off the env.js read path.
import { registerRemotes } from '@module-federation/enhanced/runtime';

// bootloader.js statically imports both remotes, so a missing URL fails as a /runtime 404 -> both required.
const RUNTIME_REMOTES = [
  { name: 'shipbob_design_system', settingKey: 'SHIPBOB_DESIGN_SYSTEM', required: true },
  { name: 'shipbob_mfe_runtime', settingKey: 'SHIPBOB_MFE_RUNTIME', required: true },
];

/** Register every runtime remote from app settings; returns false if a required remote's URL was missing/invalid. */
export function registerRuntimeRemotes(appSettings) {
  const settings = appSettings || {};
  const missingRequired = [];

  RUNTIME_REMOTES.forEach(({ name, settingKey, required }) => {
    const value = settings[settingKey];
    if (typeof value !== 'string' || !value.trim()) {
      if (required) missingRequired.push(settingKey);
      else console.error(`[inventory_control_ui] ${settingKey} missing or invalid; skipping ${name} remote`);
      return;
    }
    const origin = value.trim().replace(/\/$/, '');
    registerRemotes([{ name, entry: `${origin}/remoteEntry.js` }], { force: true });
  });

  return missingRequired.length === 0;
}
